import ApiManager from '../../utils/ApiManager'
import _ from 'lodash'

const state = {
  initLoaded: false,
  list: {
    loading: false,
    rowsPerPage: 20,
    totalItems: 0,
    headers: [
      { text: 'ブックマーク名', align: 'left', value: 'name' },
      { text: '共有設定', align: 'left', value: 'publish_setting' },
      { text: 'メモ', align: 'left', value: 'memo', format: true },
      { text: '作成者', align: 'left', value: 'user_name' },
      { text: '編集', align: 'center', value: '', type: 'edit', sortable: false }
    ],
    items: []
  },
  selectList: {
    loading: false,
    data: [],
    items: []
  }
}

const actions = {
  /**
   * ブックマーク一覧データ取得
   */
  async getBookmarkList ({ state, commit }, { pageNo, sortField, sortType, freeword }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Bookmark').bookmarkList(
      pageNo,
      state.list.rowsPerPage,
      sortField,
      sortType,
      freeword
    )
    commit('setList', response.data)
  },
  async getSelectList ({ state, commit }) {
    commit('setSelectListLoading', true)
    const response = await ApiManager.request('Bookmark').bookmarkList(
      1,
      0,
      null,
      null,
      null
    )
    commit('setSelectList', response.data)
  },
  /**
   * ブックマーク更新
   */
  async doUpdate ({ state, commit }, editData) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Bookmark').bookmarkEdit(
      {
        id: editData.id,
        publish_setting: parseInt(editData.publishSetting),
        memo: editData.memo
      }
    )
    if (response.data.code === 200000) {
      editData.response = response.data
      commit('afterUpdated', editData)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  /**
   * ブックマーク削除
   */
  async doDelete ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Bookmark').bookmarkDelete(deleteIds)
    if (response.data.code === 200000) {
      commit('afterDeleted', deleteIds)
    } else {
      commit('error')
    }
  },
  /**
   * ブックマーク登録
   */
  async doAdd ({ state, commit }, bookmarkItem) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Bookmark').bookmarkAdd({
      name: bookmarkItem.name,
      publish_setting: parseInt(bookmarkItem.publishSetting),
      memo: bookmarkItem.memo,
      history_id: bookmarkItem.history_id
    })
    if (response.data.code === 200000) {
      commit('afterAdded')
    } else {
      commit('error')
    }
  }

}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setSelectListLoading (state, data) {
    // Listローディング状態
    state.selectList.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  setSelectList (state, data) {
    state.selectList.data = data.data
    state.selectList.loading = false
    let items = []
    _.forEach(state.selectList.data, function (item) {
      let bookmark = {
        text: item.name,
        value: item
      }
      items.push(bookmark)
    })
    state.selectList.items = items
    this.dispatch('loading/loadingPageMinus')
  },
  afterUpdated (state, data) {
    let index = _.findIndex(state.list.items, function (o) { return o.id === data.id })
    let bookmark = state.list.items[index]
    bookmark.memo = data.memo
    bookmark.publish_setting = (data.publishSetting === '1' ? 'Public' : 'Private')
    state.list.items[index] = bookmark
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterDeleted (state, data) {
    this.dispatch('loading/loadingPageMinus')
    this.dispatch('pagebookmarklist/getBookmarkList', {
      pageNo: 1,
      sortField: null,
      sortType: null
    })
  },
  afterAdded (state, data) {
    this.dispatch('loading/loadingPageMinus')
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
